export default "__VITE_ASSET__ced0d3e2__"